import { Search } from 'lucide-react';

import { Button } from '@nesso/ui/primitives/button';

type Props = {
    onClick: () => void;
};

export function SearchClientTrigger({ onClick }: Props) {
    return (
        <Button
            type="button"
            variant="ghost"
            size="icon"
            onClick={onClick}
            aria-label="Search clients"
        >
            <Search className="size-4" aria-hidden="true" />
        </Button>
    );
}
